<template>
  <v-container fluid>
    <v-tabs class="mt-5" background-color="#f7f7f7">
      <v-tab link to="/receptions">주행 접수 기록</v-tab>
      <v-tab to="/deliveryReceptions">배송 접수 기록</v-tab>
    </v-tabs>
    <v-row align="center" class="ma-5">
      <v-col cols="12" sm="6">
        <v-row justify="start">
          <c-btn color="blue" outlined @click="prepareExcelData">데이터 다운로드</c-btn>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row justify="end" class="mr-3">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            offset-y
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <div>
                <v-text-field
                  v-model="startDate"
                  label="조회일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker
              v-model="startDate"
              @input="startMenu = false"
              firstDayOfWeek="1"
              :selectedDate="startDate"
              locale="ko-kr"
            ></c-date-picker>
          </v-menu>
          <div>
            <v-text-field
              v-model="searchKeyword"
              label="예약자"
              prepend-icon="search"
              maxlength="32"
            ></v-text-field>
          </div>
          <div style="display: flex; align-items: center; margin-left: 10px">
            <v-btn color="blue" outlined small @click="reqGetReceptionList">검색</v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <c-table
        :headers="headers"
        :items="items"
        :totalElements="totalElements"
        :tableOptions.sync="tableOptions"
        :loading="loading"
    >
      <template #handicapInfo="{ item }">
        <div v-for="(handicapInfo, index) in item.handicapInfo" v-key="index">
          {{ handicapInfo }}
        </div>
      </template>
      <template #destination="{ item }">
        <div>
          <v-icon x-small color="light2Grey">place</v-icon>{{ item.departure }}
        </div>
        <div>
          <v-icon x-small color="blue">place</v-icon>{{ item.destination }}
        </div>
      </template>
      <template #status="{ item }">
        <c-delivery-state-chip
          :delivery="item"
          :delivery-state-event-flag="true"
          @onChangeDeliveryState="status => onChangeDeliveryState(item, status)"
          @onReReservation="setDeliverySchedule(item)"
        />
      </template>
      <template #details="{ item }">
        <c-btn icon iconName="search" @click="linkToDetails(item)"></c-btn>
      </template>
    </c-table>
    <download-excel-dialog
        :open.sync="downloadExcelDialog"
        @reqDownloadExcel="reqDownloadExcel"
    />
    <v-overlay
        :value="loading"
    >
      <v-progress-circular
          indeterminate
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <vue-excel-xlsx
        id="excelDownloadButton"
        ref="excelDownloadRef"
        :data="excelItems"
        :columns="excelColumns"
        :filename="excelFileName"
        sheetname="배송 접수 기록"
    />

    <!-- 수동 배차 dialog -->
    <manual-delivery-dialog
        :open.sync="manualDialogOpen"
        :delivery-check-data.sync="deliveryInfo"
        :deliveryFlag.sync="deliveryFlag"
    ></manual-delivery-dialog>
  </v-container>
</template>
<script>
import DownloadExcelDialog from "../../Default/Common/DownloadExcelDialog";
import CDeliveryStateChip from "../../../components/CDeliveryStateChip";
import ManualDeliveryDialog from "../Delivery/ManualDeliveryDialog";

export default {
  name: 'ReceptionsForDelivery',
  components: { CDeliveryStateChip, DownloadExcelDialog, ManualDeliveryDialog },
  data() {
    return {
      loading: false,
      headers: [
        { text: "번호", value: "idx", align: 'center', sortable: false, width: 70 },
        { text: "접수 일시", value: "created", align: 'center', sortable: true, width: 100 },
        { text: "출발 일시", value: "startDate", align: 'center', sortable: true, width: 100 },
        { text: "예약자", value: "customerName", align: 'center', sortable: true, width: 100 },
        { text: "회원 유형", value: "customerType", align: 'center', sortable: false, width: 120 },
        { text: "장애 유형 및 정도", value: "handicapInfo", align: 'center', sortable: false, width: 150 },
        { text: "휠체어", value: "wheelchair", align: 'center', sortable: false, width: 70 },
        { text: "수급자 여부", value: "isBasicLivelihood", align: 'center', sortable: false, width: 70 },
        { text: "담당 차량", value: "vehiclePlateNo", align: 'center', sortable: false, width: 100 },
        { text: "담당 기사", value: "driverName", align: 'center', sortable: false, width: 100 },
        { text: "시내/시외", value: "fareType", align: 'center', sortable: true, width: 60 },
        { text: "출발지/도착지", value: "destination", align: 'center', sortable: false, width: 200 },
        { text: "진행상황", value: "status", align: 'center', sortable: true, width: 120 },
        { text: "업데이트 일시", value: "updated", align: 'center', sortable: false, width: 100 },
        { text: "상세보기", value: "details", align: 'center', sortable: false, width: 80 },
      ],
      items: [],
      downloadExcelDialog: false,
      excelColumns: [
        { label: "번호", field: "idx" },
        { label: "접수 일시", field: "created" },
        { label: "출발 일시", field: "startDate" },
        { label: "예약자", field: "customerName" },
        { label: "회원 유형", field: "customerType" },
        { label: "장애 유형 및 정도", field: "handicapInfoExcel" },
        { label: "휠체어", field: "wheelchair" },
        { label: "수급자 여부", field: "isBasicLivelihood" },
        { label: "담당 차량", field: "vehiclePlateNo" },
        { label: "담당 기사", field: "driverName" },
        { label: "시내/시외", field: "fareType" },
        { label: "출발지", field: "departure" },
        { label: "도착지", field: "destination" },
        { label: "진행상황", field: "statusExcel" },
        { label: "업데이트 일시", field: "updated" },
      ],
      excelItems: [],
      startMenu: false,
      startDate: this.$moment().format('YYYY-MM-DD'),
      searchKeyword: '',
      totalElements: 0,
      size: 10,
      page: 1,
      sort: 'created,desc',
      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },

      // 수동 배차
      manualDialogOpen: false,
      deliveryInfo: {},
      deliveryFlag: null,
    };
  },
  computed: {
    excelFileName() {
      return "배송 접수 기록_" + this.startDate;
    },
  },
  watch: {
    startDate() {
      this.reqGetReceptionList()
    },
    tableOptions(options) {
      this.page = options.page
      this.size = options.itemsPerPage
      if (options.sortBy.length) {
        let sortBy = options.sortBy[0] === 'startDate'
            ? 'startTime'
            : options.sortBy[0]
        this.sort = `${sortBy},${options.sortDesc[0] ? 'desc' : 'asc'}`
      } else {
        this.sort = `created,desc` // default
      }
      this.reqGetReceptionList();
    },
    deliveryFlag(newVal) {
      if (newVal && newVal === 'success') {
        this.reqGetReceptionList()
        this.deliveryFlag = null;
      }
    },
  },
  methods: {
    async reqGetReceptionList() {
      try {
        this.loading = true;
        const params = {
          customerName: this.searchKeyword,
          date: this.startDate,
          page: this.page,
          size: this.size,
          sort: this.sort,
        }

        const { data } = await this.$api.getReceptionListForDelivery(params)
        this.items = data.content.map(this.mappingItem)
        this.totalElements = data.totalElements
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqGetReservationList" });
      } finally {
        this.loading = false;
      }
    },
    async setDeliverySchedule(item) {
      const res = await this.$api.getDetailInfo(item.deliveryId); // get delivery detail info
      this.deliveryInfo = res.data;
      this.manualDialogOpen = true;
    },
    async onChangeDeliveryState(item, state) {
      try {
        const params = {
          id: item.deliveryId,
          deliveryState: state
        }
        if (state === 'dvry_wait_assignment') {
          await this.$api.updateDeliveryState(params);
        } else {
          await this.$api.cancelDelivery(params);
        }

        await this.reqGetReceptionList();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqCancelDelivery'});
      }
    },
    linkToDetails(item) {
      this.$router.push(`delivery/${item.deliveryId}`)
    },
    async prepareExcelData() {
      const { data } = await this.$api.getReceptionExcelData({ date: this.startDate })
      this.excelItems = data.receiptDeliveryList.map(this.mappingItem)
      this.downloadExcelDialog = true;
    },
    async reqDownloadExcel() {
      this.$refs.excelDownloadRef.exportExcel();
      this.downloadExcelDialog = false;
    },
    mappingItem(item, index) {
      return {
        ...item,
        created: this.$func.dateTimeToString(item.created),
        updated: this.$func.dateTimeToString(item.updated),
        idx: (index + (( this.page - 1 ) * this.size) ) + 1,
        customerType: item.customerType === '일반' ? item.customerType : `교통약자(${item.customerType})`,
        handicapInfo: item.handicapInfo ? JSON.parse(item.handicapInfo)
            .map(handicap => `${handicap.type} (${handicap.degree})`) : '-',
        handicapInfoExcel: item.handicapInfo ? JSON.parse(item.handicapInfo)
            .map(handicap => `${handicap.type} (${handicap.degree})`).join('\r\n') : '-',
        wheelchair: item.wheelchair ? item.wheelchair : '-',
        isBasicLivelihood: item.isBasicLivelihood ? '예' : '아니요',
        fareType: item.fareType.startsWith('suburban') ? '시외' : '시내',
        statusExcel: item.status.configName
      }
    }
  },
  activated() {
    this.reqGetReceptionList();
  },
};
</script>
